module.exports = __webpack_public_path__ + "png/logo-big.png?e496e6338d4809447a6f0dabb0506120";